<template>
    <div :style="injectCSSVariable()">
        <question :text="$t(item.text)" />
        <div class="matrix-choice__md">
            <b-row align-h="center">
                <b-col cols="12">
                    <div class="d-flex justify-content-center">
                        <div class="matrix-choice__row-label">
                        
                        </div>
                        <div class="d-flex mb-4 w-100">
                            <div 
                                class="matrix-choice__option-label text-center"
                                v-for="(option, i) in selectOptions"
                                :key="'option-text-'+i"
                                :style="{ width: `${100/selectOptions.length}%`}"
                            >
                                {{ option.text }}
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row align-h="center">
                <b-col cols="12">
                    <div 
                        class="matrix-choice__row d-flex justify-content-center align-items-center mb-3"
                        v-for="(choice, i) in choices"
                        :key="'choice-form-'+i"
                    >

                        <div class="matrix-choice__row-label mt-1">
                            {{ $t(choice.text) }}
                        </div>
                        <b-form-group class="mb-0 w-100">
                            <b-form-radio-group
                                class="d-flex"
                                v-model="selected[i]"
                                size="lg"
                            >
                                <b-form-radio
                                    v-for="(option, i) in selectOptions"
                                    :value="option.value"
                                    class="matrix-choice__option"
                                    :style="{ width: `${100/selectOptions.length}%`}"
                                    :key="'option-'+i"
                                >
                                </b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="matrix-choice__sm d-sm-none">
            <div class="matrix-choice__dropdown-row mb-4 px-3"
                v-for="(choice, i) in choices"
                :key="'choice-form-'+i"
            >
                <div class="matrix-choice__dropdown-label mb-2">
                    {{ $t(choice.text) }}
                </div>
                <b-form-select v-model="selected[i]">
                    <b-form-select-option :value="null" disabled hidden>
                        {{ $t(`${item.text}_DROPDOWN_PLACEHOLDER`) }}
                    </b-form-select-option>
                    <b-form-select-option v-for="(option, j) in selectOptions" :value="option.value" :key="'option-dd-'+j">
                        {{ option.text }}
                    </b-form-select-option>
                </b-form-select>
            </div>

        </div>

        <b-row>
            <b-col class="matrix-choice-other__text-input" cols="12">
                <div class="matrix-choice-other__text-input-label">
                    {{ $t(`${item.text}_OTHER_TEXT`) }}
                </div>
                <text-input
                    class="matrix-choice-other__text-input-field"
                    :validate="false"
                    @change="handleDataChange"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import itemMixin from '@/components/mixins/itemMixin'
import colorVariantMixin from '@/components/mixins/colorVariantMixin'
import question from '@/components/ui/question'
import textInput from '@/components/inputs/text'

export default {
    name: 'matrixChoiceOtherItem',
    mixins: [
        itemMixin,
        colorVariantMixin
    ],
    components: {
        question,
        textInput
    },
    props: {
        item: {
            type: Object
        }
    },
    watch: {
        selected: {
            handler: function() {
                this.answer();
            }
        }
    },
    data() {
        return {
            selected: [],
            data: null
        }
    },
    computed: {
        choices() {
            return this.item.choices
        },
        selectOptions() {
            const len = this.item.scale - this.item.scaleMin + 1
            return [...Array(len)].map((_,i) => {
                return {
                    value: i + 1,
                    text: this.scaleText(i+1, this.item.scale)
                }
            })
        }
    },
    methods: {
        handleDataChange(value) {
            this.data = value
            this.answer();
        },
        answer() {
            const data = this.data ? {
                key: 'OTHER',
                value: this.data
            } : undefined

            const results = this.selected.filter(result => result !== null)

            if(results.length === this.choices.length) {
                const result = this.choices.map((choice, i) => ({
                    choice: choice.result,
                    result: this.selected[i],
                }))

                if(data) {
                    result[result.length-1]['data'] = [data]
                }

                this.$emit('answer', result)
            }
        },
        injectCSSVariable() {
            return { '--base-color': this.baseColor };
        }
    },
    mounted() {
        const len = this.choices.length
        this.selected = [...Array(len)].map(_ => null)
    }
}
</script>
<style lang="scss">

.matrix-choice__md {
    @media screen and (max-width: 575px) {
        display: none;
    }
}

.matrix-choice__row {
    min-height: 35px;
}

.matrix-choice__row-label {
    width: 200px;
    font-size: 0.9rem;
}

@media screen and (max-width: 991px) {
    .matrix-choice__row-label {
        width: 185px;
        font-size: 0.8rem;
    }
}

.matrix-choice__option {
    width: 100px;
    margin-right: 0;
    display: inline-flex;
    justify-content: center;

    .custom-control-input:checked ~ .custom-control-label::before {
        border-color: var(--base-color) !important;
        background-color: var(--base-color) !important;
    }
}

.matrix-choice__option-label {
    font-size: 0.8rem;
    // width: 100px;
}

@media screen and (max-width: 1199px) {
    .matrix-choice__option {
        // width: 70px;
        margin: 0 5px;
    }

    .matrix-choice__option-label {
        font-size: 0.7rem;
        // width: 70px;
        margin: 0 5px;
    }
}



.matrix-choice__row .custom-control {
    padding-left: 1.75rem !important;
}

.matrix-choice-other__text-input {
    margin-top: 16px;
    min-height: 62px;
    display: flex;
    justify-content: center;
    width: 100%;
    @media screen and (max-width: 575px) {
        display: block;
        margin-bottom: 3rem;
    }
}

.matrix-choice-other__text-input-label {
    width: 200px;
    font-size: 0.9rem;
    @media screen and (max-width: 991px) {
        font-size: 0.8rem;
    }
    @media screen and (min-width: 576px) {
        margin-top: 0.5rem;
    }
    @media screen and (max-width: 575px) {
        font-size: 1rem;
        margin-bottom: 0.75rem;
        padding: 0 1rem;
    }
}

.matrix-choice-other__text-input-field {
    width: 100%;
    padding: 0 3rem;
    @media screen and (max-width: 1199px) {
        padding: 0 2rem;
    }
    @media screen and (max-width: 767px) {
        padding: 0 1.3rem 0 0.75rem;
    }
    @media screen and (max-width: 575px) {
        padding: 0 1rem;
    }
}
</style>